import { render } from "./AppFooter.vue?vue&type=template&id=621854e1&scoped=true&ts=true&lang=pug"
import script from "./AppFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppFooter.vue?vue&type=script&lang=ts&setup=true"

import "./AppFooter.vue?vue&type=style&index=0&id=621854e1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621854e1"]])

export default __exports__